import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "kind", "isCloseable", "closeButtonText", "closeButtonAriaLabel", "onClose", "role", "closeIcon", "className", "data-test", "CustomIcon"];
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AlertIcon, InfoIcon, AvailableIcon, CloseIcon } from '@sainsburys-tech/bolt-icons';
import StyledAlert from './Alert.styles';

var Alert = function Alert(_ref) {
  var children = _ref.children,
      kind = _ref.kind,
      isCloseable = _ref.isCloseable,
      closeButtonText = _ref.closeButtonText,
      closeButtonAriaLabel = _ref.closeButtonAriaLabel,
      onClose = _ref.onClose,
      role = _ref.role,
      closeIcon = _ref.closeIcon,
      className = _ref.className,
      dataTest = _ref['data-test'],
      CustomIcon = _ref.CustomIcon,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      toggleShow = _useState2[1];

  if (!show) return null;
  return /*#__PURE__*/React.createElement(StyledAlert, _extends({
    kind: kind,
    role: role,
    className: className,
    isCloseable: isCloseable,
    "data-test": dataTest
  }, props), kind === 'success' && !CustomIcon && /*#__PURE__*/React.createElement(AvailableIcon, {
    "aria-hidden": "true"
  }), kind === 'info' && !CustomIcon && /*#__PURE__*/React.createElement(InfoIcon, {
    "aria-hidden": "true"
  }), kind === 'error' && !CustomIcon && /*#__PURE__*/React.createElement(AlertIcon, {
    "aria-hidden": "true"
  }), CustomIcon && /*#__PURE__*/React.createElement(CustomIcon, {
    "aria-hidden": "true"
  }), children, isCloseable && /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": closeButtonAriaLabel,
    "data-test": "".concat(dataTest, "-button-close"),
    onClick: function onClick() {
      toggleShow(false);
      onClose();
    }
  }, closeIcon ? /*#__PURE__*/React.createElement(CloseIcon, {
    "aria-hidden": "true"
  }) : closeButtonText));
};

Alert.displayName = 'Alert';
Alert.propTypes = {
  /**
   * Optional prop to specify the kind of the Alert
   */
  kind: PropTypes.oneOf(['success', 'info', 'error']),

  /**
   * Optional prop to allow the alert to be dismissed/closed
   */
  isCloseable: PropTypes.bool,

  /**
   * Optional prop to change the text shown for the close button
   */
  closeButtonText: PropTypes.string,

  /**
   * Optional prop to change the aria-label for the close button
   */
  closeButtonAriaLabel: PropTypes.string,

  /**
   * Optional prop for an onClose callback func
   */
  onClose: PropTypes.func,

  /**
   * Optional prop to specify the role of the Alert
   */
  role: PropTypes.string,

  /**
   * Optional prop to customize the icon for the Alert
   */
  CustomIcon: PropTypes.elementType,

  /**
   * Specify an optional className to be added to your Alert
   */
  className: PropTypes.string,

  /**
   * Specify an optional data-test attribute to be added to your Alert for e2e testing
   */
  'data-test': PropTypes.string,

  /**
   * Optional prop to show close icon for dismissal of the Alert
   */
  closeIcon: PropTypes.bool
};
Alert.defaultProps = {
  kind: 'success',
  role: 'alert',
  CustomIcon: null,
  isCloseable: true,
  closeButtonText: 'Close',
  closeButtonAriaLabel: 'close the alert',
  'data-test': 'component-alert',
  closeIcon: false,
  onClose:
  /* istanbul ignore next */
  function onClose() {}
};
export default Alert;